import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import { createTheme, ThemeProvider } from '@mui/material/styles';
import { UserContextProvider } from './context/UserContext';

export const theme = createTheme({
    palette: {
        primary: {
            // main: '#1976D2',
            main: '#1d4ed8',
        },
        secondary: {
            // main: '#40C4FF',
            main: '#3b82f6',
        },
    },
    typography: {
        fontFamily: '"Inter", sans-serif',
    },
});

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <ThemeProvider theme={theme}>
        <React.StrictMode>
            <UserContextProvider>
                <App />
            </UserContextProvider>
        </React.StrictMode>
    </ThemeProvider>
);
